<template>
  <v-col cols="12" class="pa-0">
    <v-row>
      <v-col cols="12">
        <span>{{ titleLabel || 'Наименование' }} * (<TranslationIcon />)</span>
        <v-text-field
          outlined
          :id="idTitle"
          :autofocus="!title && autofocusEnabled"
          :error-messages="titleError"
          :disabled="isLoading"
          :loading="isLoading"
          :value="title"
          @input="$emit('change:title', $event.trim())"
        />
        <v-btn
          v-if="isSlugEnabled"
          :disabled="!title"
          x-small
          outlined
          color="primary"
          @click="updateSlugHandler"
        >
          Сформировать SLUG
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="isSlugEnabled">
      <v-col cols="12">
        <span>{{ slugLabel || 'Уникальное имя для URL' }} *</span>
        <v-text-field
          outlined
          id="slug"
          :error-messages="slugError"
          :disabled="isLoading"
          :loading="isLoading"
          :value="slug"
          @change="$emit('change:slug', $event.trim())"
          @input="$emit('input:slug', $event)"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import TranslationIcon from '@/components/translation-icon/translationIcon'
import slugify from '@/utils/slugify'
export default {
  name: 'InputTitleSlug',
  components: { TranslationIcon },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isSlugEnabled: {
      type: Boolean,
      default: true
    },
    autofocusEnabled: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: null
    },
    titleLabel: {
      type: String,
      default: null
    },
    titleError: {
      type: Array,
      default: () => []
    },
    slug: {
      type: String,
      default: null
    },
    slugLabel: {
      type: String,
      default: null
    },
    slugError: {
      type: Array,
      default: () => []
    },
    idTitle: {
      type: [Number, String],
      default: 'title'
    }
  },
  methods: {
    updateSlugHandler () {
      this.$emit('change:slug', slugify(this.title))
    }
  }
}
</script>
